import React, { useEffect, useRef, useState } from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import { useAppContext } from 'context/AppContext'
import { useEventContext } from 'context/EventContext'

import KnowledgeBase from './components/KnowledgeBase'
import Learn from './components/Learn'

import classes from './CategoryHubsCarousel.module.scss'

/** @type {import("./types").default} */
const CategoryHubsCarousel = ({ hubsCarousel }) => {
  const carouselRef = useRef()
  const { addEvent } = useEventContext()
  const [pageIndex, setPageIndex] = useState(0)
  const [count, setCount] = useState(0)
  const { isCypressTakingSnapshots } = useAppContext()

  const scrollToPage = page => {
    const firstChildrenWidth = carouselRef.current.firstElementChild.offsetWidth
    carouselRef.current.scrollTo({ left: firstChildrenWidth * page, behavior: 'smooth' })
  }

  const onScroll = () => {
    const scrollPosition = carouselRef.current.scrollLeft
    const pageWidth = carouselRef.current.firstElementChild.offsetWidth

    const division = scrollPosition / pageWidth
    const page = Math.round(division)

    setPageIndex(page)
  }

  useEffect(() => {
    if (hubsCarousel.length > 1 && !isCypressTakingSnapshots) {
      const timer = setTimeout(() => {
        if (count === 5) scrollToPage(pageIndex === hubsCarousel.length - 1 ? 0 : pageIndex + 1)
        else setCount(count + 1)
      }, 1000)
      return () => clearTimeout(timer)
    }
  }, [count, hubsCarousel, isCypressTakingSnapshots, pageIndex])

  useEffect(() => {
    setCount(0)
  }, [pageIndex])

  return (
    <>
      <Grid
        container
        className={clsx('CategoryHubsCarousel', classes.root)}
        ref={carouselRef}
        onScroll={onScroll}
        data-testid="carousel"
      >
        {hubsCarousel.map((carouselItem, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <Grid item xs={12} key={`page-${i}`} className={classes.page}>
            {carouselItem.type === 'HomeLearn' && <Learn item={carouselItem} />}
            {carouselItem.type === 'HomeCategoryHub' && <KnowledgeBase item={carouselItem} />}
          </Grid>
        ))}
      </Grid>
      <div className={classes.pageSelector} data-testid="page-selector">
        {hubsCarousel.length > 1 &&
          hubsCarousel.map((_, i) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`pagination-${i}`}
              role="button"
              className={clsx({ [classes.selected]: i === pageIndex })}
              onClick={() => scrollToPage(i)}
              {...addEvent({
                engagementComponent: 'category_hub',
                engagementDestination: 'article_change-page',
                engagementDetails: 'bullet-point',
                name: 'engagement_facet_click',
              })}
            />
          ))}
      </div>
    </>
  )
}

export default CategoryHubsCarousel
